import { ref } from '@vue/composition-api';
import store from '@/store';
import toast from '@/utils/toast';
import studentStoreModule from '../studentStoreModule';

export default function useChangeClassModal(emit) {
  const fromClass = ref()
  const toClass = ref()
  const fromSchool = ref()
  const toSchool = ref()
  const isSubmitting = ref(false)
  const toastification = toast()
  const STORE_MODULE_NAME = 'student';

  // Register module
  if (!store.hasModule(STORE_MODULE_NAME)) {
    store.registerModule(STORE_MODULE_NAME, studentStoreModule);
  }


  const onSubmit = async bvModalEvt => {
    console.log(bvModalEvt)
    bvModalEvt.preventDefault();
    if (!fromClass.value || !toClass.value) {
      toastification.showToastErrorWithMessage('Vui lòng chọn đầy đủ lớp học');
      return;
    }
    isSubmitting.value = true;
    console.log('hahaha', fromClass, toClass);
    store.dispatch('student/changeStudentClass', {
      from: fromClass.value.id,
      to: toClass.value.id
    }).then(() => emit('refetch-data')).then(() => {
      toastification.showToastCreateSuccess();

    }).catch(error => {
      toastification.showToastErrorWithMessage('Cập nhật thất bại');
      isSubmitting.value = false;
    }).finally(() => {
      isSubmitting.value = false
    });

  }

  const resetModal = () => {
    fromClass.value = null
    toClass.value = null
    fromSchool.value = null
    toSchool.value = null
  }

  return {
    fromClass,
    toClass,
    fromSchool,
    toSchool,
    resetModal,
    onSubmit,
    isSubmitting
  }
}